import { server_connection } from 'config';

export const GET_AUTH_ROLES = '[USER] GET AUTH ROLES';

export function getAuthRoles() {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/auth_roles/list')
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_AUTH_ROLES,
                    payload: responseData
                });
            });
    }
}


// WEBPACK FOOTER //
// src/store/actions/medprocure/data.actions.js